// Selected entities that survive every per-entity filter (visibility, isolation, dimming...) —
// none of which depend on the viewport — in selection order. Built once per selection/filter
// change so a zoom/pan frame only has to cull by bounds and stroke, instead of redoing the
// handle lookup and filter chain for every selected entity on every frame.
export function buildSelectedOverlayList(handles, byHandle, isDrawable, getBounds) {
  const list = []
  for (const handle of handles) {
    const entity = byHandle.get(handle)
    if (entity && isDrawable(entity, handle)) list.push({ handle, entity, bounds: getBounds(entity) })
  }
  return list
}
